import { FC } from "react"
import { StyledTableLink } from "./tableLink.styled"
import { TableLinkProps } from "./tableLinkProps.interface"

const TableLink: FC<TableLinkProps> = ({ label, to }) => {
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    event.stopPropagation()
  }
  return (
    <StyledTableLink to={to} onClick={handleClick}>
      {label}
    </StyledTableLink>
  )
}

export default TableLink
